import React, { Component } from 'react';
import { ScaleLoader } from 'react-spinners';

export class LoadingSpinner extends Component {
    render() {
        const { className } = this.props;

        return (
            <div className={`${undefined !== className ? className : "loading"}`}>
                <ScaleLoader color="#4189C7" />
            </div>
        )
    }
} 